import { render, staticRenderFns } from "./TicketingPaymentFooter.vue?vue&type=template&id=36109816&scoped=true"
import script from "./TicketingPaymentFooter.vue?vue&type=script&lang=ts"
export * from "./TicketingPaymentFooter.vue?vue&type=script&lang=ts"
import style0 from "./TicketingPaymentFooter.vue?vue&type=style&index=0&id=36109816&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36109816",
  null
  
)

export default component.exports